export function shiftList() {
  return '{shiftListAll{id, name, active, startTime, finalTime, classQuantity, consolidationTime}}';
}

export function shiftListByFilter(filter) {
  return `{
  shiftListByFilter(
    filter: ${JSON.stringify(filter).replace(/"([^(")"]+)":/g, '$1:')}
  ) {
    id
    name
    active
    startTime
    finalTime
    classQuantity
    consolidationTime
    intervalQuantity,
    shiftItems {
        id,
        sequence,
        displaySequence,
        startAt,
        endAt,
        type
    }
  }
}`;
}

export function shiftMutationSave(values) {
  const mutationQuery = `mutation {
        shifSave(
          shift: {id: ${values.id ? values.id : 0}
                  , name: "${values.name}"
                  , active: ${values.active}
                  , classQuantity: ${values.classQuantity}
                  , startTime: "${values.startTime}"
                  , finalTime: "${values.finalTime}"
                  , filterByStatus: false
                  , updaterId: 0
                  , consolidationTime: "${values.consolidationTime}"  
                  intervalQuantity: ${values.intervalQuantity}        
                  shiftItems: ${JSON.stringify(values.items).replace(
                    /"([^(")"]+)":/g,
                    '$1:'
                  )}                         
                  }),
      {id}
  }`;
  return mutationQuery;
}

export function shiftMutationRemove(id) {
  return `mutation {shiftRemove(id: ${id})}`;
}

export function shiftListAll() {
  return `{shiftListAll{
        id, 
        name, 
        active, 
        startTime, 
        finalTime, 
        classQuantity, 
        consolidationTime, 
        shiftItems {
          id
          sequence
          displaySequence
          startAt
          endAt
          type
        }
  }}`;
}

export function shiftLabelValueListByFilter(filter) {
  return `{
  shiftListByFilter(
    filter: ${JSON.stringify(filter).replace(/"([^(")"]+)":/g, '$1:')}
  ) {
    id
    label
    value
  }
}`;
}
